<template lang="html">

  <section class="banner-productos animation">

    <section class="showroom-productos" :type="data">

      <div class="container">


        <div class="contenedor-title-intro column-center">
          <h2 class="title -xs" v-html="$t(`productos.${data}.intro_productos`)"></h2>
        </div>

        <div class="product-list row-center ais">
          <template v-for="(producto, key) in $t(`productos.${data}.productos`)" >
            <article class="producto-el column-between" :active="selected == key && showInfo" @click="setSelected(key)" :data="key">
              <h2 class="title -xs">{{producto.nombre}}</h2>
              <img :src="`/static/img/productos/${$t(`productos.${data}.slug`)}/productos/${producto.id}.png`" alt="">
            </article>
          </template>
        </div>

        <div class="slider-product-list row-center ais" v-if="showSlider">
          <slick ref="slick" :options="slickOptions" class="slider-productos">
            <template v-for="(producto, key) in $t(`productos.${data}.productos`)" >
              <article class="producto-el column-between" :active="selected == key && showInfo" @click="setSelected(key)">
                <h2 class="title -xs">{{producto.nombre}}</h2>
                <img :src="`/static/img/productos/${$t(`productos.${data}.slug`)}/productos/${producto.id}.png`" alt="">
              </article>
            </template>
          </slick>
        </div>

      </div>

    </section>


    <section class="ficha-info column-center" :show="showInfo">


      <a @click="closeInfo" class="cerrar">✕</a>

      <div class="container ficha-info-wrapper row-between ais" :show="showInfo">

        <template v-if="!!selected">

          <h2 class="title -black -xs">{{$t(`productos.${data}.productos['${selected}'].nombre`)}}</h2>

          <div class="left">

            <article class="el" v-if="!!textos.productos[data].productos[selected].tipo_uva">
              <p>
                <strong>{{$t('tips_productos.tipo_uva')}}</strong>
                {{$t(`productos.${data}.productos['${selected}'].tipo_uva`)}}
              </p>
            </article>

            <article class="el" v-if="!!textos.productos[data].productos[selected].tipo_vino">
              <p>
                <strong>{{$t('tips_productos.tipo_vino')}}</strong>
                {{$t(`productos.${data}.productos['${selected}'].tipo_vino`)}}
              </p>
            </article>


            <article class="el stats" v-if="!!textos.productos[data].productos[selected].servicio">
              <ul class="row-start">
                <li v-if="!!textos.productos[data].productos[selected].cantidad" class="-i-botella">{{$t(`productos.${data}.productos['${selected}'].cantidad`)}}</li>
                <li v-if="!!textos.productos[data].productos[selected].graduacion">{{$t(`productos.${data}.productos['${selected}'].graduacion`)}}</li>
                <li v-if="!!textos.productos[data].productos[selected].servicio">{{$t(`productos.${data}.productos['${selected}'].servicio`)}}</li>
              </ul>
            </article>

            <article class="el" v-if="!!textos.productos[data].productos[selected].elaboracion">
              <p>
                <strong>{{$t('tips_productos.elaboracion')}}</strong>
                {{$t(`productos.${data}.productos['${selected}'].elaboracion`)}}
              </p>
            </article>

            <article class="el" v-if="!!textos.productos[data].productos[selected].descripcion">
             <p>
              <strong>{{$t(`productos.${data}.productos['${selected}'].descripcion`)}}</strong>
            </p>
          </article>

          <article class="el" v-if="!!textos.productos[data].productos[selected].ingredientes">
            <p>
              <strong>{{$t('tips_productos.ingredientes')}}</strong>
              {{$t(`productos.${data}.productos['${selected}'].ingredientes`)}}
            </p>
          </article>

          <article class="el" v-if="!!textos.productos[data].productos[selected].caracteristicas">
            <p>
              <strong>{{$t('tips_productos.caracteristicas')}}</strong>
              {{$t(`productos.${data}.productos['${selected}'].caracteristicas`)}}
            </p>
          </article>

          
      <article class="el" v-if="!!textos.productos[data].productos[selected].curacion">
        <p>
          <strong>{{$t('tips_productos.curacion')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].curacion`)}}
        </p>
      </article>

      <article class="el" v-if="!!textos.productos[data].productos[selected].apariencia">
        <p>
          <strong>{{$t('tips_productos.apariencia')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].apariencia`)}}
        </p>
      </article>

      <article class="el" v-if="!!textos.productos[data].productos[selected].conservacion">
        <p>
          <strong>{{$t('tips_productos.conservacion')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].conservacion`)}}
        </p>
      </article>

      <article class="el" v-if="!!textos.productos[data].productos[selected].notadecata">
        <p>
          <strong>{{$t('tips_productos.notadecata')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].notadecata`)}}
        </p>
      </article>

        </div>

        <div class="right">

          <article class="el" v-if="!!textos.productos[data].productos[selected].gastronomia">
           <p>
            <strong>{{$t('tips_productos.gastronomia')}}</strong>
            {{$t(`productos.${data}.productos['${selected}'].gastronomia`)}}
          </p>
        </article>

        <article class="el -notas" v-if="!!textos.productos[data].productos[selected].notas_cata">
         <p>
          <strong>{{$t('tips_productos.notas_cata')}}</strong>
          "{{$t(`productos.${data}.productos['${selected}'].notas_cata.texto`)}}"
        </p>
        <i v-if="!!textos.productos[data].productos[selected].notas_cata.autor">{{$t(`productos.${data}.productos['${selected}'].notas_cata.autor`)}}</i>
      </article>

      <article class="el" v-if="!!textos.productos[data].productos[selected].maridaje">
        <p>
          <strong>{{$t('tips_productos.maridaje')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].maridaje`)}}
        </p>
      </article>


      <article class="el" v-if="!!textos.productos[data].productos[selected].valoresnutricionales">
        <p>
          <strong>{{$t('tips_productos.valoresnutricionales')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].valoresnutricionales`)}}
        </p>
      </article>

<article class="el" v-if="!!textos.productos[data].productos[selected].alergenos">
        <p>
          <strong>{{$t('tips_productos.alergenos')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].alergenos`)}}
        </p>
      </article>

      <article class="el" v-if="!!textos.productos[data].productos[selected].durabilidad">
        <p>
          <strong>{{$t('tips_productos.durabilidad')}}</strong>
          {{$t(`productos.${data}.productos['${selected}'].durabilidad`)}}
        </p>
      </article>

      <article class="el stats" v-if="!!textos.productos[data].productos[selected].peso">
        <ul class="row-start">
         <template v-for="el in $t(`productos.${data}.productos['${selected}'].peso`)">
          <li class="-i-peso">{{el}}</li>
        </template>
      </ul>
    </article>

    <article class="el" v-if="!!textos.productos[data].productos[selected].cantidades">
      <ul class="row-start">
        <template v-for="el in $t(`productos.${data}.productos['${selected}'].cantidades`)">
          <li class="cantidades -i-botella">{{el}}</li>
        </template>
      </ul>
    </article>
     
<article class="el stats" v-if="!!textos.productos[data].productos[selected].tamano">
      <ul class="row-start">
        <template v-for="el in $t(`productos.${data}.productos['${selected}'].tamano`)">
          <li class="-i-tamaño">{{el}}</li>
        </template>
      </ul>
    </article>
    
    
    <article class="el" v-if="textos.productos[data].productos[selected].premios.length > 0">
     <p><strong>{{$t('tips_productos.premios')}}</strong></p>
     <div class="listado-premios row-start">
       <template v-for="(premio,key) in $t(`productos.${data}.premios.premios`)">
        <div class="premio" :doble="!!premio.doble" v-if="textos.productos[data].productos[selected].premios.includes(key)">
          <router-link title="Haz click para ver el premio" :to="`${$t('enlaces.productos')}/${$route.params.id}${$t('enlaces.premios')}#${key}`">
          <img :alt="premio.texto" :src="`/static/img/productos/${data}/premios/${key}.png`">
        </router-link>
      </div>
    </template>

  </div>

</article>

</div>

</template>
<div class="certificados">
  <div>
    <img src="/static/img/IFS-logo.png" alt="" />
    <span class="link-certificados"  v-html="$t('Certificados2')"></span>
  </div>
</div>
</div>


<div class="contenedor-botones" :show="showInfo">

  <template v-if="!!selected">

    

    <a :href="`/static/img/productos/${data}/productos/${$t(`productos.${data}.productos.${selected}.id`)}${'-'+lang}.pdf`" target="_blank" class="btn -black">
      <span>{{$t('tips_productos.descargar_ficha')}}</span>
    </a>

  </template>

</div>



</section>



</section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  import Slick from 'vue-slick';


  import router from '@/router';

  export default  {
    name: 'banner-productos',
    props : ['data'],
    data(){
      return {
        selected : '',
        showInfo :false,
        showSlider : false,
        slickOptions: {
          slidesToShow: 3,
          infinite : true,
          responsive: [

          {
            breakpoint: 1096,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          ]
        },
      }
    },
    mounted(){
      this.showSlider = true;
      setTimeout(e => {
        if(!!this.$route.params.idproducto){
         this.setSelected(this.$route.params.idproducto);
        }
      },1000)
    },
    methods :{
      setSelected : function(el){

        
        if(!!this.selected){
          $('html, body').animate({
            scrollTop: $(".banner-beneficios").position().top - 900
          },1000);
        }else{
          $('html, body').animate({
            scrollTop: $(".banner-beneficios").position().top - 200
          },1000);
        }

        this.selected = el;
        this.showInfo = true;

        let url = this.textos.enlaces.productos+'/'+this.$route.params.id+'/'+this.selected

        router.replace(url);

  
        
      },
      closeInfo : function(){
        this.showInfo = false;
        setTimeout(()=>{this.selected = ''},1000);
        $('html, body').animate({
          scrollTop: $(".banner-productos").position().top - 200
        },1000);
      }
    },
    computed :{
      ...mapGetters({
        textos : 'getTexts',
        lang : 'getLanguage'
      })
    },
    watch : {
      '$route.params.id' : function(){
        this.selected = '';
        this.showInfo = false;
        this.showSlider = false;
        setTimeout(e =>{
          this.showSlider = true;
        },100)
      }
    },
    components : {
      Slick
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .listado-premios{
    width: 100%;
    position: relative;
    z-index: 3;
  }

  .listado-premios .premio{
    width: 50px;
    height: 50px;
    display: inline-block;
    padding: 5px;
&:nth-child(3){
  width: 56px;
    height: 52px;
}
    &[doble=true]{
      width: 100px;
      a{
        width: 90px;
        height: 40px;
        display: inline-block;
      }
    }

    img{
      max-width: 100%;
      max-height: 100%;
      display: inline-block;
    }
  }

  .slider-product-list{
    display: none;
  }

  .contenedor-title-intro{

    .title{
      margin-bottom: 0;
      padding-bottom: 0;
      display: inline-block;
      line-height: 1.8em;
      font-family: 'pennellinoregular';
      font-size: 40px;
      line-height: 1.6em;
      &::before{
        display:inline-block;
        left: 50%;
        transform: translateX(-50%);
      }


    }

  }

  .fake-banner{
    height: 150px;
    width: 100%;
    display: inline-block;
    background: $mud-brown;
  }

  .banner-productos .producto-el[data=caja] img{
    height: 300px;
  }

  @media screen and (max-width: 1023px){
    .banner-productos .ficha-info[show=true]{
      height: auto;
      padding: 50px 0;
      position: relative;
    }

    .banner-productos .showroom-productos{
      padding: 50px 0;
      height: auto;
    }

    .banner-productos .ficha-info .ficha-info-wrapper > div{
      width: calc(50% - 15px);
    }
  }

  @media screen and (max-width: 1096px){

    [type="vino"] .product-list,
    [type="queso"] .product-list,
    [type="cava"] .product-list{
      display: none;
    }

    [type="vino"] .slider-product-list,
    [type="queso"] .slider-product-list,
    [type="cava"] .slider-product-list{
      display: inline-block;
      margin-top: 20px;
      padding-bottom: 40px;
      width: 100%;
      button.slick-next{
        top: auto;
        bottom: 0;
      }
    }

    .banner-productos .producto-el{
      text-align: center;
      
      .title{
        width: 100%;
        display: inline-block;
      }
      img{
        margin: 0 auto;
        max-height: 220px;
      }

      &[active=true] img{
        transform: scale(1.2) translateY(20px);
      }
    }

    .banner-productos [type="azafran"] .producto-el[active=true] img{
      transform:scale(1) translateY(0px);
    }

    .banner-productos [type="aceite"] .producto-el{
      width: 50%;
    }

    .banner-productos [type="aceite"] .producto-el img{
      height: auto;
      max-width: 100%;
    }

  }

  @media screen and (max-width: 768px){

    .banner-productos .ficha-info .ficha-info-wrapper > div{
      width: 100%;
    }

    .banner-productos .ficha-info .left .el:last-of-type{
      border-bottom: 1px solid black;
    }

    .banner-productos .ficha-info .el li{
      width: 100%;
      border-right: none;
      border-bottom: 1px solid black;
      padding: 15px 0;
      text-align: left;
      padding-left: 25px;
      margin-left: 0;

      &:last-of-type{
        border-bottom:none;
      }
    }

    .banner-productos .ficha-info .el li.-i-botella.cantidades{
      width: 50%;
      margin-left: 0;
      border-bottom:none;
      padding: 0;
      text-align: left;
      margin-bottom: 10px;
      padding-left: 15px;
    }

    .banner-productos .ficha-info .el.stats{
      padding: 0;
    }

    .listado-premios .premio{
      width: 75px;
      height: 75px;
    }
  }

  @media screen and (max-width: 700px){

    .contenedor-title-intro .title{
      font-size: 32px;
      line-height: 30px;
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/views/productos/banner-productos.vue